var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('page-header'),_c('main',[_c('router-view'),_c('help')],1),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }